export default function configureStore(state = {messages: 0, notifications: 0}, action) {
    switch (action.type) {
      case 'CLEAR_MESSAGES':
          return {messages: 0, notifications: state.notifications}
      case 'CLEAR_NOTIFICATIONS':
          return {messages: state.messages, notifications: 0}
      case 'SET_MESSAGES' :
          return {...state, messages: action.count}
      case 'SET_NOTIFICATIONS' :
          return {...state, notifications: action.count}  
      case 'INCREMENT_MESSAGES': 
          return { messages: state.messages + ((action.count !== undefined) ? action.count : 1), notifications: state.notifications }
      case 'DECREMENT_MESSAGES':
          return { messages: state.messages - ((action.count !== undefined) ? action.count : 1), notifications: state.notifications }
      case 'INCREMENT_NOTIFICATIONS': 
          return { messages: state.messages, notifications: state.notifications + ((action.count !== undefined) ? action.count : 1) }
      case 'DECREMENT_NOTIFICATIONS': 
          return { messages: state.messages, notifications: state.notifications - ((action.count !== undefined) ? action.count : 1) }
      default:
          return state
    }
  }


// WEBPACK FOOTER //
// ./src/store/index.js